// import lib
import { lazy } from "react";

const routes = [
  {
    path: "/user_group",
    element: lazy(() => import("../../pages/UserAccess/UserGroup/index")),
  },
  {
    path: "/user_group/add",
    element: lazy(() => import("../../pages/UserAccess/UserGroup/create-edit")),
  },
  {
    path: "/user_group/edit/:id",
    element: lazy(() => import("../../pages/UserAccess/UserGroup/create-edit")),
  },
];

export default routes;
